module.exports = __webpack_public_path__ + "static/media/20.c64431a2.jpg";